import Vue from "vue";
import VueRouter from "vue-router";

// Import route groups
import adminRoutes from "./routes/admin.routes";
import authRoutes from "./routes/auth.routes";
import firmRoutes from "./routes/firm.routes";
import businessPlanRoutes from "./routes/business-plans.routes";
import balanceRoutes from "./routes/balances.routes";
import esgRoutes from "./routes/esg.routes";
import dsrRoutes from "./routes/dsr.routes";
import documentRoutes from "./routes/documents.routes";
import enterpriseRoutes from "./routes/enterprise.routes";
import miscRoutes from "./routes/misc.routes";

// Import router guards
import { beforeEachGuard, afterEachGuard } from "./guards";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    redirect: { name: "auth.login" },
  },
  adminRoutes,
  authRoutes,
  firmRoutes,
  businessPlanRoutes,
  balanceRoutes,
  esgRoutes,
  dsrRoutes,
  documentRoutes,
  enterpriseRoutes,
  ...miscRoutes, // Spread for multiple misc routes
];

const router = new VueRouter({
  mode: "history",
  routes,
});

// Apply guards
router.beforeEach(beforeEachGuard);
router.afterEach(afterEachGuard);

export default router;
